<!-- <div class="info-box celo-content">
  <div class="breadcrums">
    <a [routerLink]="['/workplaces']">Workspaces ></a>&nbsp;&nbsp;<a [routerLink]="['/workplaces']"><span>{{company.name}} ></span></a> &nbsp;&nbsp;<span>{{company.name}} ></span>
  </div>
    <app-title-box [title]="company.name" [subtitle]="company.countryCode" [flag]="company.isActive==true?'Active':'Inactive'"></app-title-box>
</div> -->
{{id}}